/**
 * Custom Cart Drawer - Advanced JavaScript Functionality
 * Replicates Upcart functionality with subscription management
 */
 

const currencyEl = document.getElementById("currency-data");
const currency = currencyEl?.dataset.currency;
const currencySymbol = currencyEl?.dataset.currencySymbol;
const currencyNEW = currencySymbol || currency;



class CustomCartDrawer {
  constructor(options = {}) {
    this.cartDrawerId = options.cartDrawerId || 'custom-cart-global';
    this.subscriptionConfig = {
      welcomeKitSellingPlanIds: [
        "5290426590",
        "5290393822",
        "5290459358",
        "5290492126",
        "5940871390"
      ],
      transformationKitSellingPlanIds: ["6043664606"],
      unflavouredJarId: "43220908769502"
    };

    this.upsellProducts = options.upsellProducts || [];
    this.cart = null;

    this.init();
  }

  init() {
    this.bindEvents();
    this.loadCart();
    this.handleUpcartConflicts();
  }

  handleUpcartConflicts() {
    // Add body class to indicate custom cart is active
    document.body.classList.add('custom-cart-active');

    // Disable Upcart event listeners if they exist
    if (window.upcartOnCartLoaded) {
      window.upcartOnCartLoaded = () => {};
    }
    if (window.upcartOnCartUpdated) {
      window.upcartOnCartUpdated = () => {};
    }

    // Hide any existing Upcart elements
    const upcartElements = document.querySelectorAll('#upCart, #UpcartPopup, [id*="upcart"], [class*="upcart"]');
    upcartElements.forEach(el => {
      el.style.display = 'none';
      el.style.visibility = 'hidden';
      el.style.pointerEvents = 'none';
    });

    // Override global cart functions that might be used by Upcart
    window.openCart = () => this.open();
    window.closeCart = () => this.close();

    // Intercept AJAX add to cart calls
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      const response = await originalFetch(...args);

      // Check if this was an add to cart request
      if (args[0] && typeof args[0] === 'string' && args[0].includes('/cart/add')) {
        console.log('AJAX add to cart detected');
        // Trigger cart item added event after successful add
        if (response.ok) {
          document.dispatchEvent(new CustomEvent('cart:item-added'));
        }
      }

      return response;
    };
  }

  bindEvents() {
    // Listen for cart changes
    document.addEventListener('cart:updated', (event) => {
      this.cart = event.detail;
      this.updateDisplay();
    });

    // Listen for cart additions
    document.addEventListener('cart:item-added', () => {
      this.loadCart();
      // Auto-open cart immediately after adding item
      this.open();
    });

    // Global cart open function
    window.openCustomCart = () => this.open();
    window.closeCustomCart = () => this.close();

    // Bind cart triggers
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-custom-cart-trigger]');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Custom cart trigger clicked');
        this.open();
      }
    });

    // Handle form submissions for cart updates
    document.addEventListener('submit', (e) => {
      if (e.target.closest('[data-custom-cart-form]')) {
        e.preventDefault();
        this.handleFormSubmit(e);
      }
    });

    // Handle add to cart buttons with new-atc-class
    document.addEventListener('click', async (e) => {
  const button = e.target.closest('.new-atc-class');

  if (button && button.type === 'submit') {
    const form = button.closest('form');

    if (form && form.action.includes('/cart/add')) {
      e.preventDefault(); // Prevent default form submission
      console.log('New ATC class button clicked, handling via AJAX');

      try {
        // Collect form data
        const formData = new FormData(form);

        // Submit via fetch
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
          const result = await response.json();
          console.log('Item added to cart:', result);

          // Trigger custom cart event
          document.dispatchEvent(new CustomEvent('cart:item-added', {
            detail: result
          }));

          // ✅ Check for "direct-checkout" class
          if (button.classList.contains('direct-checkout')) {
            console.log('Direct checkout button clicked, redirecting...');
            setTimeout(() => {
              window.location.href = '/checkout';
            }, 500); // small delay to ensure cart updates
          }

        } else {
          console.error('Add to cart failed:', response.statusText);
        }
      } catch (error) {
        console.error('Add to cart error:', error);
      }
    }
  }
});

  }

  async loadCart() {
    try {
      const response = await fetch('/cart.js');
      this.cart = await response.json();
      this.updateDisplay();
      this.initSubscriptionControls();
    } catch (error) {
      console.error('Error loading cart:', error);
    }
  }

  open() {
    console.log('Opening custom cart drawer with ID:', this.cartDrawerId);
    const drawer = document.querySelector(`#${this.cartDrawerId} .custom-cart-drawer`);
    const overlay = document.querySelector(`#${this.cartDrawerId} .custom-cart-drawer-overlay`);

    console.log('Drawer element:', drawer);
    console.log('Overlay element:', overlay);

    if (!drawer || !overlay) {
      console.error('Cart drawer elements not found');
      return;
    }

    drawer.classList.add('active');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';

    this.loadCart();
    this.loadUpsells();

    // Trigger custom event
    document.dispatchEvent(new CustomEvent('cart:opened'));
  }

  close() {
    const drawer = document.querySelector(`#${this.cartDrawerId} .custom-cart-drawer`);
    const overlay = document.querySelector(`#${this.cartDrawerId} .custom-cart-drawer-overlay`);

    if (!drawer || !overlay) return;

    drawer.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  updateDisplay() {
    if (!this.cart) return;

    this.updateCartCount();
    this.updateCartSubtotal();
    this.renderCartItems();
  }

  updateCartCount() {
    const countElements = document.querySelectorAll('#custom-cart-item-count, [data-cart-count], [data-bind="itemCount"]');
    countElements.forEach(el => {
      el.textContent = this.cart.item_count;
    });

    // Update header cart count badge visibility
    const headerCartElements = document.querySelectorAll('.header-cart');
    headerCartElements.forEach(el => {
      if (this.cart.item_count > 0) {
        el.classList.add('has-cart-count');
      } else {
        el.classList.remove('has-cart-count');
      }
    });
  }

  updateCartSubtotal() {
    const subtotalElements = document.querySelectorAll('#custom-cart-subtotal-price, [data-cart-subtotal]');
    subtotalElements.forEach(el => {
      el.textContent = this.formatMoney(this.cart.total_price);
    });
  }

  renderCartItems() {
    const container = document.getElementById('custom-cart-items-container');
    if (!container) return;

    container.innerHTML = '';

    if (this.cart.items.length === 0) {
      container.innerHTML = this.getEmptyCartHTML();
      $('#custom-cart-global').addClass('empty-cart'); 
      console.log('updated')
      return;
    } else {
      console.log('updated2')
      $('#custom-cart-global').removeClass('empty-cart');
    }

    const itemsList = document.createElement('ul');
    itemsList.className = 'custom-cart-items';

    this.cart.items.forEach((item, index) => {
      const itemElement = this.createCartItemElement(item, index + 1);
      itemsList.appendChild(itemElement);
    });

    container.appendChild(itemsList);
  }

  getEmptyCartHTML() {
    return `
      <div style="text-align: center; padding: 40px 20px; color: var(--cart-text-color);">
        
        <h3 style="margin-bottom: 10px; font-size: 18px;">Your cart is empty</h3>
        <p style="margin-bottom: 20px; opacity: 0.7;">Add your favorite items to your cart.</p>
        <a href="/products/armra-unflavored-jar" style="
          font-family: 'Relative', sans-serif;
          background: #333 !important;
          text-transform: uppercase;
          letter-spacing: 1.5px;
          font-weight: 500 !important;
          font-size: 16px !important;
          line-height: 20px !important;
          padding: 16px 8px !important;
          color: #fff;
          cursor: pointer;
          width: 100%;
          display: block;
        ">SHOP NOW</a>
      </div>
    `;
  }

  createCartItemElement(item, lineIndex) {
    const li = document.createElement('li');
    li.className = 'custom-cart-item';
    li.setAttribute('data-line-item', lineIndex);
    li.setAttribute('data-variant-id', item.variant_id);

    const variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    const sellingPlanName = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name : '';

    li.innerHTML = `
      <div class="custom-cart-item-content">
        <a href="${item.url}" class="custom-cart-item-image-wrapper">
          <img src="${item.image}" alt="${item.title}" class="custom-cart-item-image">
        </a>
        <div class="custom-cart-item-info">
          <div class="custom-cart-item-header">
            <h4 class="custom-cart-item-title">
              <a href="${item.url}">${item.product_title}</a>
            </h4>
            <button class="custom-cart-item-remove" onclick="customCartDrawer.removeItem(${lineIndex})">
              <svg viewBox="0 0 20 20">
                <path d="M11.5 8.25a.75.75 0 0 1 .75.75v4.25a.75.75 0 0 1-1.5 0v-4.25a.75.75 0 0 1 .75-.75Z"></path>
                <path d="M9.25 9a.75.75 0 0 0-1.5 0v4.25a.75.75 0 0 0 1.5 0v-4.25Z"></path>
                <path fill-rule="evenodd" d="M7.25 5.25a2.75 2.75 0 0 1 5.5 0h3a.75.75 0 0 1 0 1.5h-.75v5.45c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311c-.642.327-1.482.327-3.162.327h-.4c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311c-.327-.642-.327-1.482-.327-3.162v-5.45h-.75a.75.75 0 0 1 0-1.5h3Zm1.5 0a1.25 1.25 0 1 1 2.5 0h-2.5Zm-2.25 1.5h7v5.45c0 .865-.001 1.423-.036 1.848-.033.408-.09.559-.128.633a1.5 1.5 0 0 1-.655.655c-.074.038-.225.095-.633.128-.425.035-.983.036-1.848.036h-.4c-.865 0-1.423-.001-1.848-.036-.408-.033-.559-.09-.633-.128a1.5 1.5 0 0 1-.656-.655c-.037-.074-.094-.225-.127-.633-.035-.425-.036-.983-.036-1.848v-5.45Z"></path>
              </svg>
            </button>
          </div>
          ${variantTitle ? `<div class="custom-cart-item-variant">${variantTitle}</div>` : ''}
          ${sellingPlanName ? `<div class="custom-cart-item-properties">${sellingPlanName}</div>` : ''}
          <div class="custom-cart-item-controls">
            <div class="custom-cart-quantity-selector">
              <button class="custom-cart-quantity-btn" onclick="customCartDrawer.updateQuantity(${lineIndex}, ${item.quantity - 1})" ${item.quantity <= 0 ? 'disabled' : ''}>
                <svg viewBox="0 0 20 20" width="12" height="12">
                  <path fill-rule="evenodd" d="M5 10c0-.414.336-.75.75-.75h8.5c.414 0 .75.336.75.75s-.336.75-.75.75h-8.5c-.414 0-.75-.336-.75-.75Z"></path>
                </svg>
              </button>
              <input type="text" class="custom-cart-quantity-input" value="${item.quantity}" onchange="customCartDrawer.updateQuantity(${lineIndex}, this.value)" min="1">
              <button class="custom-cart-quantity-btn" onclick="customCartDrawer.updateQuantity(${lineIndex}, ${item.quantity + 1})">
                <svg viewBox="0 0 20 20" width="12" height="12">
                  <path d="M10.75 5.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v3.5h-3.5c-.414 0-.75.336-.75.75s.336.75.75.75h3.5v3.5c0 .414.336.75.75.75s.75-.336.75-.75v-3.5h3.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-3.5v-3.5Z"></path>
                </svg>
              </button>
            </div>
            <div class="custom-cart-item-pricing">
              ${item.original_price > item.final_price ? `<div class="custom-cart-price-compare">${this.formatMoney(item.original_price)}</div>` : ''}
              <div class="custom-cart-price">${this.formatMoney(item.final_line_price)}</div>
            </div>
          </div>
        </div>
      </div>
      ${this.getSubscriptionUpgradeHTML(item, lineIndex)}
    `;

    return li;
  }

  getSubscriptionUpgradeHTML(item, lineIndex) {
    // Check if this item has subscription options
    if (!item.product_has_only_default_variant && item.variant_id.toString() === this.subscriptionConfig.unflavouredJarId) {
      if (!item.selling_plan_allocation) {
        // Show upgrade to subscription button for one-time purchases
        return `
          <div class="custom-cart-subscription-upgrade">
            <button class="custom-cart-subscription-btn" onclick="customCartDrawer.upgradeToSubscription(${lineIndex})">
              Upgrade to SUBSCRIBE & SAVE
            </button>
          </div>
        `;
      }
    }
    return '';
  }

  initSubscriptionControls() {
    // Wait for elements to be rendered
    setTimeout(() => {
      this.controlSellingPlanOptionUI();
    }, 100);
  }

  controlSellingPlanOptionUI() {
    const { welcomeKitSellingPlanIds, transformationKitSellingPlanIds, unflavouredJarId } = this.subscriptionConfig;

    // Get all select elements for the unflavoured jar
    const selectElements = document.querySelectorAll(`.custom-cart-subscription-select[data-variant-id="${unflavouredJarId}"]`);

    selectElements.forEach((selectEl) => {
      const options = selectEl.querySelectorAll('option');

      options.forEach((option) => {
        // Always allow one-time purchase
        if (option.value === 'otp') return;

        // Check for special kit types via data attributes
        const isWelcomeKit = selectEl.dataset.welcomeKit;
        const isTransformationKit = selectEl.dataset.transformationKit;

        if (isWelcomeKit) {
          if (!welcomeKitSellingPlanIds.includes(option.value)) {
            option.remove();
          }
        } else if (isTransformationKit) {
          if (!transformationKitSellingPlanIds.includes(option.value)) {
            option.remove();
          }
        } else {
          // For regular products, exclude kit-specific plans
          if (welcomeKitSellingPlanIds.includes(option.value) ||
              transformationKitSellingPlanIds.includes(option.value)) {
            option.remove();
          }
        }
      });
    });
  }

  async updateQuantity(lineIndex, newQuantity) {
    const quantity = Math.max(0, parseInt(newQuantity));

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: lineIndex,
          quantity: quantity
        })
      });

      if (!response.ok) throw new Error('Update failed');

      this.cart = await response.json();
      this.updateDisplay();

      // Trigger custom event for other components
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: this.cart
      }));

    } catch (error) {
      console.error('Error updating quantity:', error);
      this.loadCart(); // Reload on error
    }
  }

  async removeItem(lineIndex) {
    await this.updateQuantity(lineIndex, 0);
  }

  async upgradeToSubscription(lineIndex) {
    // This would typically open a modal or update the line item
    // For now, we'll redirect to the product page with subscription
    const item = this.cart.items[lineIndex - 1];
    if (item) {
      window.location.href = `${item.url}?selling_plan=4748247262`; // Default subscription plan
    }
  }

  async loadUpsells() {
    const container = document.getElementById('custom-cart-upsells-container');
    if (!container) return;

    // This would typically fetch recommended products via AJAX
    // For now, we'll use static upsell products
    if (this.upsellProducts.length === 0) {
      container.innerHTML = '<p style="text-align: center; opacity: 0.7;">No recommendations available</p>';
      return;
    }

    container.innerHTML = '';

    this.upsellProducts.forEach(product => {
      const upsellElement = this.createUpsellElement(product);
      container.appendChild(upsellElement);
    });
  }

  createUpsellElement(product) {
    const div = document.createElement('div');
    div.className = 'custom-cart-upsell-item';

    div.innerHTML = `
      <a href="${product.url}">
        <img src="${product.image}" alt="${product.title}" class="custom-cart-upsell-image">
      </a>
      <div class="custom-cart-upsell-info">
        <a href="${product.url}" class="custom-cart-upsell-title">${product.title}</a>
        <div class="custom-cart-upsell-price">${this.formatMoney(product.price)}</div>
        <button class="custom-cart-upsell-btn" onclick="customCartDrawer.addUpsellToCart('${product.variant_id}')">
          ADD
        </button>
      </div>
    `;

    return div;
  }

  async addUpsellToCart(variantId) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1
          }]
        })
      });

      if (!response.ok) throw new Error('Failed to add product');

      // Reload cart to reflect changes
      await this.loadCart();

      // Show success feedback
      this.showNotification('Product added to cart!');

    } catch (error) {
      console.error('Error adding upsell to cart:', error);
      this.showNotification('Error adding product to cart', 'error');
    }
  }

  async addFreeShippingItem() {
    // Add the free shipping item from the announcement bar
    const freeItemData = {
      items: [{
        id: 43220908769502,
        quantity: 1,
        selling_plan: 4748247262
      }]
    };

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(freeItemData)
      });

      await this.loadCart();
    } catch (error) {
      console.error('Error adding free item:', error);
    }
  }

  applyDiscountCode(code) {
    if (!code) return;

    // Shopify handles discount codes at checkout
    window.location.href = `/checkout?discount=${encodeURIComponent(code)}`;
  }

  formatMoney(cents) {
    

    // Fallback formatting
    return `${currencyNEW}${(cents / 100).toFixed(2)}`;
  }

  showNotification(message, type = 'success') {
    // Create and show a temporary notification
    const notification = document.createElement('div');
    notification.className = `custom-cart-notification custom-cart-notification--${type}`;
    notification.textContent = message;
    notification.style.cssText = `
      animation: slideInRight 0.3s ease;
    `;

    document.body.appendChild(notification);

    setTimeout(() => {
      notification.style.animation = 'slideOutRight 0.3s ease';
      setTimeout(() => {
        document.body.removeChild(notification);
      }, 300);
    }, 3000);
  }

  handleFormSubmit(event) {
    const form = event.target;

    if (form.classList.contains('custom-cart-discount-form')) {
      const input = form.querySelector('.custom-cart-discount-input');
      this.applyDiscountCode(input.value);
    }
  }
}

// Initialize the cart drawer when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  // Only initialize if custom cart is enabled
  const customCartElement = document.querySelector('#custom-cart-global');
  if (!customCartElement) {
    console.log('Custom cart not enabled');
    return;
  }

  // Configuration can be passed from Liquid template
  const config = window.customCartConfig || {};

  console.log('Initializing custom cart drawer with config:', config);

  window.customCartDrawer = new CustomCartDrawer({
    cartDrawerId: config.cartDrawerId || 'custom-cart-global',
    upsellProducts: config.upsellProducts || []
  });

  // Load initial cart data immediately
  window.customCartDrawer.loadCart();
});

// Add CSS animations if not already present
if (!document.querySelector('#custom-cart-animations')) {
  const style = document.createElement('style');
  style.id = 'custom-cart-animations';
  style.textContent = `
    @keyframes slideInRight {
      from { transform: translateX(100%); opacity: 0; }
      to { transform: translateX(0); opacity: 1; }
    }
    @keyframes slideOutRight {
      from { transform: translateX(0); opacity: 1; }
      to { transform: translateX(100%); opacity: 0; }
    }
  `;
  document.head.appendChild(style);
}